// Queries
export { default as getOrders } from './getOrders';
export { default as getShortedWaves } from './getShortedWaves';
export { default as getShortedOrders } from './getShortedOrders';
export { default as getShortedOrderLines } from './getShortedOrderLines';

// Mutations
export { default as addOrdersToWave } from './addOrdersToWave';
export { default as removeOrdersFromWave } from './removeOrdersFromWave';
export { default as createWave } from './createWave';
export { default as releaseWave } from './releaseWave';
export { default as publishShortedOrder } from './publishShortedOrder';
export { default as sendOrdersToDispatchTrack } from './sendOrdersToDispatchTrack';
export { default as removeOrdersFromDispatchTrack } from './removeOrdersFromDispatchTrack';
export { default as refreshOrdersFromSidekick } from './refreshOrdersFromSidekick';

export { default as uploadDeliveryReceiptFromDispatchTrack } from './uploadDeliveryReceiptFromDispatchTrack';



// WEBPACK FOOTER //
// ./src/queries/index.js